










































import Vue from 'vue';
import { Client } from '@/types';
import ClientUsage from '@/account-price-plan/ClientUsage.vue';

export default Vue.extend({
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  components: {
    'client-usage': ClientUsage,
  },
});
